export function colorOrFallback(color) {
  // use the following color as a fallback:
  // rgb(197, 244, 10) = [0.7725490196078432, 0.9568627450980393, 0.0392156862745098, 1]
  const fallbackColor = [0.7725490196078432, 0.9568627450980393, 0.0392156862745098, 1];
  return color || fallbackColor;
}

export function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

function componentToHex(c) {
  const hex = Math.round(c * 255).toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

const shortHexRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
const fullHexRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;

export function hexToRgba(hex) {
  if (!hex) {
    return hex;
  }
  const full = hex.replace(shortHexRegex, (m, r, g, b) => r + r + g + g + b + b);
  const result = fullHexRegex.exec(full);
  return result
    ? [hexToComponent(result[1]), hexToComponent(result[2]), hexToComponent(result[3]), 1]
    : null;
}

function hexToComponent(h) {
  return parseInt(h, 16) / 255;
}

/**
 * Converts an [r, g, b, a] array (channels in 0–1) to a CSS `rgba(...)` string.
 * Returns null for invalid input.
 */
export function rgbaArrayToCss(rgba) {
  if (!Array.isArray(rgba) || rgba.length < 3) return null;
  const [r, g, b, a = 1] = rgba;
  const inUnitRange = (v) => Number.isFinite(v) && v >= 0 && v <= 1;
  if (!inUnitRange(r) || !inUnitRange(g) || !inUnitRange(b) || !inUnitRange(a)) return null;
  return `rgba(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(b * 255)}, ${a})`;
}

/**
 * True when every channel of `color` is at or above 95% intensity — i.e. the
 * color is white or close enough that a swatch of it would be invisible
 * against a white background. Accepts a hex string or an [r, g, b, a] array
 * (channels in 0–1). Returns false for invalid input.
 */
export function isNearWhite(color) {
  const rgba = Array.isArray(color) ? color : hexToRgba(color);
  if (!rgba || rgba.length < 3) return false;
  const [r, g, b] = rgba;
  return r >= 0.95 && g >= 0.95 && b >= 0.95;
}
